import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants"
import {errors, splitKpi, vision} from "@signals"


export const OPTIONS = [
	{ label: 'By Market', value: GROUPED_BY.COUNTRY },
	{ label: 'By Retailer', value: GROUPED_BY.RETAILER },
	{ label: 'By Brand', value: GROUPED_BY.BRAND },
	{ label: 'By Seller', value: GROUPED_BY.SELLER },
	{ label: 'By Sku', value: GROUPED_BY.SKU },
	{ label: 'By Company', value: GROUPED_BY.COMPANY }
]

export default function SplitKpiSelect({ ...props }) {
	return <SelectSeeker
		options={OPTIONS}
		multiple
		isClearable
		error={errors.value?.splitKpi}
		label="Split By"
		placeholder=" "
		value={splitKpi.value}
		onChange={e => {
			splitKpi.value = e.target.value
			if (splitKpi.value.includes(GROUPED_BY.SELLER) && !splitKpi.value.includes(GROUPED_BY.RETAILER) && vision.value === GROUPED_BY.COUNTRY) 
				splitKpi.value = [...splitKpi.value, GROUPED_BY.RETAILER]
		}}
		{...props}
	/>
}